(function ($) {
    "use strict";

    const isIE = window.navigator.userAgent.match(/(MSIE|Trident)/);

    const wholeEl = document.querySelector('.home-explained');

    if (!wholeEl) return;

    const buttonsContainerEl = wholeEl.querySelector('.buttons-container');
    const $buttons = $('a.button', buttonsContainerEl);
    const $slider = $('.contents', wholeEl);
    const $slickNext = $('.next', wholeEl);
    const $slickPrev = $('.prev', wholeEl);

    if(isIE){
        // we remove images from slides.
        $('.content-image-column', $slider).remove();
        $('.explained-content-block.with-image', $slider).addClass('offset-md-3');
    }

    $slider.slick({
        prevArrow: $slickPrev,
        nextArrow: $slickNext,
        adaptiveHeight: true,
        infinite: false,
        mobileFirst: true,
        speed: 200,
        responsive: [{

            breakpoint: 1200,
            settings: {
                fade: true,
            }

        }]
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){

        const $btn = $buttons.eq(nextSlide);
        $buttons.not($btn).removeClass('on');
        $btn.addClass('on');

    });

    $buttons.on('click', function(event){
        const $btn = $(this);
        $slider.slick('slickGoTo', parseInt($btn.attr('data-slide-index')) -1 );
        event.preventDefault();
    });


})(jQuery);